<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <DefaultTmpl :mode="$appUtils.isMobile() ? 'mobile_search' : 'default'">
        <template v-slot:main>
            <head-utils title="Dashboard"/>
            <breadcrumb :items="[{label: 'Dashboard', path: '/dashboard'}]"/>

            <div class="container-fluid-grid">
                <div class="row">
                    <div class="col-6">
                        <div class="summarize">
                            <svg-icon class="icon" icon="balance-scale"/>
                            <span class="qtd"><span>CONTRATOS</span><br>{{summarize.qtd}}</span>
                            <span class="tons"><span>TONELADAS</span><br>{{summarize.tons | formatNumber(3)}}</span>
                        </div>
                    </div>
                    <div class="col-6">
                      <router-link to="/market_places" v-ripple-tap title="Market Places" class="btn btn-primary btn-theme-1"><svg-icon icon="book-open"/> Market Place</router-link>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="horizontal-chart">
                            <ChartJs type="line"
                                     style="background-color: rgba(255,255,255,.2)"
                                     :width="$appUtils.isDesktop() ? '100' : '800'"
                                     :height="$appUtils.isDesktop() ? '30' : '200'"
                                     :data="dataQtd"
                                     :options="{...optionsQtd, responsive: $appUtils.isDesktop()}"/>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="horizontal-chart">
                        <ChartJs type="line"
                                 style="background-color: rgba(255,255,255,.2)"
                                 :width="$appUtils.isDesktop() ? '100' : '800'"
                                 :height="$appUtils.isDesktop() ? '30' : '200'"
                                 :data="dataTons"
                                 :options="{...optionsQtd, responsive: $appUtils.isDesktop()}"/>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 col-sm-6 col-md-3">
                        <h5 class="t-c ellipsis">Maiores Vendedores</h5>
                        <ChartJs type="doughnut"
                                 style="background-color: rgba(255,255,255,.2)"
                                 width="100"
                                 height="100"
                                 :data="dataBestSellers"
                                 :options="optionsDoughnut"/>
                    </div>
                    <div class="col-6 col-sm-6 col-md-3">
                        <h5 class="t-c ellipsis">Maiores Compradores</h5>
                        <ChartJs type="doughnut"
                                 style="background-color: rgba(255,255,255,.2)"
                                 width="100"
                                 height="100"
                                 :data="dataBestBuyers"
                                 :options="optionsDoughnut"/>
                    </div>
                    <div class="col-6 col-sm-6 col-md-3">
                        <h5 class="t-c ellipsis">Produtos vs Qtd Negócios</h5>
                        <ChartJs type="doughnut"
                                 style="background-color: rgba(255,255,255,.2)"
                                 width="100"
                                 height="100"
                                 :data="dataProdVsDeals"
                                 :options="optionsDoughnutProdQtd"/>
                    </div>
                    <div class="col-6 col-sm-6 col-md-3">
                        <h5 class="t-c ellipsis">Toneladas por Produto</h5>
                        <ChartJs type="doughnut"
                                 style="background-color: rgba(255,255,255,.2)"
                                 width="100"
                                 height="100"
                                 :data="dataTonsVsProd"
                                 :options="optionsDoughnut"/>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-12 t-c">
                        <h5 class="ellipsis">Toneladas vs Mês vs Dia da Semana</h5>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-4">
                        <br v-if="$appUtils.isMobile()">
                        <div class="row">
                            <div class="col-4">
                                <select class="form-control form-control-sm" v-model="yearOne" @change="changeYear('one')">
                                    <option v-for="y in yearsDayMonth" :value="y" :key="y">{{y}}</option>
                                </select>
                            </div>
                            <div class="col-8">
                                <select class="form-control form-control-sm"
                                        @change="changeYear('one')"
                                        v-model="productOneId">
                                    <option :value="null">[TODOS PRODUTOS]</option>
                                    <option v-for="c in categories"
                                            :key="c.id"
                                            :value="c.id">{{c.name}}</option>
                                </select>
                            </div>
                        </div>
                        <CalendarHeat :values="dataYearOne"/>
                    </div>
                    <div class="col-12 col-md-4">
                        <br v-if="$appUtils.isMobile()">
                        <div class="row">
                            <div class="col-4">
                                <select class="form-control form-control-sm"
                                        v-model="yearTwo"
                                        @change="changeYear('two')">
                                    <option v-for="y in yearsDayMonth" :value="y" :key="y">{{y}}</option>
                                </select>
                            </div>
                            <div class="col-8">
                                <select class="form-control form-control-sm"
                                        @change="changeYear('two')"
                                        v-model="productTwoId">
                                    <option :value="null">[TODOS PRODUTOS]</option>
                                    <option v-for="c in categories"
                                            :key="c.id"
                                            :value="c.id">{{c.name}}</option>
                                </select>
                            </div>
                        </div>
                        <CalendarHeat :values="dataYearTwo"/>
                    </div>
                    <div class="col-12 col-md-4">
                        <br v-if="$appUtils.isMobile()">
                        <div class="row">
                            <div class="col-4">
                                <input type="text" class="form-control form-control-sm" value="Todos Anos" disabled/>
                            </div>
                            <div class="col-8">
                                <select class="form-control form-control-sm"
                                        @change="changeYear('three')"
                                        v-model="productThreeId">
                                    <option :value="null">[TODOS PRODUTOS]</option>
                                    <option v-for="c in categories"
                                            :key="c.id"
                                            :value="c.id">{{c.name}}</option>
                                </select>
                            </div>
                        </div>
                        <CalendarHeat :values="dataYearThree"/>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-12 col-md-9">
                        <h5 class="t-c ellipsis">Movimentação em Toneladas Todos Anos</h5>
                        <div class="horizontal-chart">
                            <ChartJs type="line"
                                     style="background-color: rgba(255,255,255,.2)"
                                     :width="$appUtils.isDesktop() ? '100' : '800'"
                                     :height="$appUtils.isDesktop() ? '30' : '200'"
                                     :data="dataTonsYears"
                                     :options="optionsTonsYears"/>
                        </div>
                    </div>
                    <div class="col-12 col-md-3 t-c">
                        <h5 class="ellipsis">Acumulado Toneladas Ano</h5>
                        <div style="height: 250px; width: 250px;display: inline-block">
                        <ChartJs type="doughnut"
                                 style="background-color: rgba(255,255,255,.2)"
                                 width="100"
                                 height="100"
                                 :data="dataTonsYearsTotal"
                                 :options="optionsDoughnut"/>
                        </div>
                    </div>
                </div>
                <hr>

                <div class="row">
                    <div class="col-12 col-md-9">
                        <div class="row">
                            <div class="col-12" style="display: grid; grid-template-columns: 1fr 100px;align-items: center;justify-content: center">
                                <h5 class="t-c ellipsis">Movimentação em Toneladas Produto</h5>
                                <select class="form-control form-control-sm"
                                        @change="changeProdYearsTons"
                                        v-model="productTonsYearsId">
                                    <option v-for="c in categories"
                                            :key="c.id"
                                            :value="c.id">{{c.name}}</option>
                                </select>
                                <br>
                            </div>
                        </div>
                        <div class="horizontal-chart">
                            <ChartJs type="line"
                                     style="background-color: rgba(255,255,255,.2)"
                                     :width="$appUtils.isDesktop() ? '100' : '800'"
                                     :height="$appUtils.isDesktop() ? '30' : '200'"
                                     :data="dataTonsProdYears"
                                     :options="optionsTonsYears"/>
                        </div>
                    </div>
                    <div class="col-12 col-md-3 t-c">
                        <div class="row">
                            <div class="col-12" style="display: grid; grid-template-columns: 1fr;align-items: center;justify-content: center">
                                <h5 class="ellipsis">Acumulado Toneladas Ano/Produto</h5>
                            </div>
                        </div>
                        <div style="height: 250px; width: 250px; display: inline-block;">
                            <br>
                            <ChartJs type="doughnut"
                                     style="background-color: rgba(255,255,255,.2)"
                                     width="100"
                                     height="100"
                                     :data="dataTonsProdYearsTotal"
                                     :options="optionsDoughnut"/>
                        </div>
                    </div>
                </div>
                <br>
                <br>
                <br>
                <br>


                <modal size="medium"
                       v-show="showModalFilter"
                       id="ModalDashboardFilter">

                    <template v-slot:header>
                        <h3 class="title">Filtrar</h3>
                    </template>

                    <template v-slot:body>
                        <div class="container-fluid-grid">
                            <div class="form-row">
                                <div class="col-md-3 col-6 form-group">
                                    <label for="dashboardFilterStart">Início</label>
                                    <div class="input-group input-group-sm">
                                        <input type="text"
                                               id="dashboardFilterStart"
                                               v-model="search_params.start"
                                               placeholder="DD/MM/AAAA"
                                               v-flatpickr
                                               v-mask="'##/##/####'"
                                               class="form-control form-control-sm t-c plch-center n-m-r-right">
                                        <div class="input-group-append">
                                            <div class="input-group-text">
                                                <svg-icon icon="calendar-alt"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-6 form-group">
                                    <label for="dashboardFilterEnd">Fim</label>
                                    <div class="input-group input-group-sm">
                                        <input type="text"
                                               id="dashboardFilterEnd"
                                               v-model="search_params.end"
                                               placeholder="DD/MM/AAAA"
                                               v-flatpickr
                                               v-mask="'##/##/####'"
                                               class="form-control form-control-sm t-c plch-center n-m-r-right">
                                        <div class="input-group-append">
                                            <div class="input-group-text">
                                                <svg-icon icon="calendar-alt"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 form-group">
                                    <label for="dashboardFilterProds">Produtos</label>
                                    <SelectX
                                            input-id="dashboardFilterProds"
                                            placeholder="Produtos"
                                            allow-include-new="false"
                                            v-model="search_params.products"
                                            :data-source="categories.map(c => {return {id: c.id, label: c.name}})"
                                    />
                                </div>
                            </div>
                            <div class="row" v-if="$appStorage.userIsProfile(['admin', 'admin_all', 'admin_view'])">
                                <div class="col-12 form-group">
                                    <label for="dashboardFilterUsers">Corretores</label>
                                    <SelectX
                                            input-id="dashboardFilterUsers"
                                            placeholder="Corretores"
                                            allow-include-new="false"
                                            v-model="search_params.brokers"
                                            data-source="/v1/dashboard/search_users"
                                    />
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-slot:footer>
                        <button type="button"
                                @click="() => {
                                    searchDefaultCharts();
                                    showModalFilter = false;
                                }"
                                class="btn btn-sm btn-success">
                            <svg-icon icon="check"/> Aplicar
                        </button>
                        <button type="button"
                                @click="showModalFilter = false"
                                class="btn btn-sm btn-dark">
                            <svg-icon icon="times"/>
                            Fechar
                        </button>
                    </template>
                </modal>

                <Fab type="button"
                     icon="filter"
                     size="normal"
                     :customStyle="$appUtils.isMobile() ? {bottom: '80px'} : {}"
                     @click="showModalFilter = true"
                     color="blue"/>
            </div>
        </template>
        <template v-slot:footer>
            <BottomMenuMob v-if="$appUtils.isMobile()"/>
        </template>
    </DefaultTmpl>
</template>

<script>
    import DefaultTmpl from '@/templates/DefaultTmpl'
    import BottomMenuMob from '@/components/particles/BottomMenuMob'
    import ChartJs from "@/components/particles/ChartJs";
    import CalendarHeat from "../components/particles/CalendarHeat";
    import {createNamespacedHelpers} from 'vuex'
    const {mapGetters, mapActions} = createNamespacedHelpers('products');
    import dayjs from "dayjs";
    import {formatNumber, humanizeNumber, isDesktop} from "../utils/Utils";
    import Big from 'big.js'
    import Fab from "../components/particles/Fab";
    import SelectX from "../components/particles/SelectX";
    import StorageUtils from "../utils/StorageUtils";

    const FILTER_PARAMS = '__FILTER_PARAMS_DASH_COMM';

    const defaultOption = {
        responsive: true,
        legend: {
            display: true,
            position: 'bottom'
        },
        title: {
            display: false
        },
        animation: {
            animateScale: true,
            animateRotate: true
        },
        tooltips: {
            callbacks: {
                title: function(tooltipItems, data) {
                    return data.datasets[tooltipItems[0].datasetIndex].label;
                }
            }
        }
    };

    const optionTons = {
        legend: {position: 'top'},
        tooltips: {
            mode: 'label',
            callbacks: {
                title: function(tooltipItems, data) {
                    return `${data.labels[tooltipItems[0].index]}`;
                },
                label(tooltipItem, data) {
                    let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                    value = value ? formatNumber(value, 3) : '0,000';
                    return `${data.datasets[tooltipItem.datasetIndex].label}: ${value}`;
                }
            }
        },
        scales: {
            yAxes: [{
                ticks: {
                    min: 0,
                    callback: function(label) {
                        return humanizeNumber(label, 3);
                    }
                }
            }]
        }
    };

    export default {
        name: "Dashboard",
        components: {DefaultTmpl, BottomMenuMob, ChartJs, CalendarHeat, Fab, SelectX},
        data() {
            return {
                search_params: {
                    start: null,
                    end: null,
                    products: [],
                    brokers: [],
                },
                summarize : {
                    qtd: 0,
                    tons: 0
                },
                showModalFilter: false,
                dataYearOne: [],
                dataYearTwo: [],
                dataYearThree: [],
                yearOne: new Date().getFullYear(),
                yearTwo: new Date().getFullYear() - 1,
                productOneId: null,
                productTwoId: null,
                productThreeId: null,
                productTonsYearsId: null,
                dataQtd: {},
                dataTons: {},
                options: {...defaultOption},
                optionsQtd: {
                    ...defaultOption,
                    legend: {position: 'top'},
                    scales: {
                        yAxes: [{
                            ticks: {
                                min: 0
                            }
                        }]
                    }
                },
                optionsTons: {
                    ...defaultOption,
                    ...optionTons
                },
                optionsDoughnut: {...defaultOption,
                    legend: {
                        display: false
                    },
                    tooltips: {
                        callbacks: {
                            title: function(tooltipItems, data) {
                                return data.datasets[tooltipItems[0].datasetIndex].label;
                            },
                            label(tooltipItem, data) {
                                return `${data.labels[tooltipItem.index]} Tons ${formatNumber(data.datasets[0].data[tooltipItem.index], 3)}`;
                            }
                        }
                    }
                },
                optionsDoughnutProdQtd: {
                    legend: {
                        display: false
                    },
                    tooltips: {
                        callbacks: {
                            title: function(tooltipItems, data) {
                                return data.datasets[tooltipItems[0].datasetIndex].label;
                            }
                        }
                    }
                },
                optionsTonsYears: {
                    ...optionTons,
                    responsive: isDesktop(),
                    legend: {
                        position: 'bottom'
                    }
                },
                dataBestSellers: {
                    datasets: [{
                        data: [],
                        backgroundColor: []
                    }],
                    labels: []
                },
                dataBestBuyers: {
                    labels: []
                },
                dataProdVsDeals: {
                    labels: []
                },
                dataTonsVsProd: {
                    labels: []
                },
                dataTonsYears: {
                    labels: [],
                    datasets: []
                },
                dataTonsYearsTotal: {
                    labels: []
                },
                dataTonsProdYears: {
                    labels: [],
                    datasets: []
                },
                dataTonsProdYearsTotal: {
                    labels: []
                },
                resultProdsYear: []
            }
        },
        methods: {
            ...mapActions(['loadCategories']),
            searchDefaultCharts() {

                const params = new URLSearchParams();
                params.set('start', this.search_params.start);
                params.set('end', this.search_params.end);

                this.search_params.products.forEach(p => params.append('product_category_ids[]', p.id));
                this.search_params.brokers.forEach(b => params.append('broker_ids[]', b.id));

                StorageUtils.saveObject(FILTER_PARAMS, this.search_params);

                this.$appHttp.get(`/v1/dashboard?${params.toString()}`)
                    .then(({data}) => {
                        let newData = {
                            labels: [],
                            datasets: [{
                                borderColor: '#1AB39A',
                                backgroundColor: 'rgba(26,179,154,0.1)',
                                data: [],
                                label: 'Quantidade de Negócios',
                                borderWidth: 1,
                                pointRadius: 2,
                                fill: true
                            }]
                        };
                        data.deals_by_month.forEach(d => {
                            newData.labels.push(d.grouped);
                            newData.datasets[0].data.push(d.value);
                        });
                        this.dataQtd = {...newData};

                        newData = {
                            labels: [],
                            datasets: [{
                                borderColor: '#1AB39A',
                                backgroundColor: 'rgba(26,179,154,0.1)',
                                data: [],
                                label: 'Toneladas Negociadas',
                                borderWidth: 1,
                                pointRadius: 2,
                                fill: true
                            }]
                        };
                        data.tons_by_month.forEach(d => {
                            newData.labels.push(d.grouped);
                            newData.datasets[0].data.push(parseFloat(d.value));
                        });
                        this.dataTons = {...newData};

                        this.fillDoughnut(data.best_sellers, 'dataBestSellers');
                        this.fillDoughnut(data.best_buyers, 'dataBestBuyers');
                        this.fillDoughnut(data.product_quantity, 'dataProdVsDeals');
                        this.fillDoughnut(data.product_tons, 'dataTonsVsProd');

                        this.fillTonsYear(data.years, 'dataTonsYears', 'dataTonsYearsTotal');

                        this.summarize.qtd = data.sales_qtd;
                        this.summarize.tons = parseFloat(data.sales_tons);

                        if (!this.productTonsYearsId) {
                            this.productTonsYearsId = data.prod_years_tons[0].id;
                            this.resultProdsYear = data.prod_years_tons;
                        }
                        this.changeProdYearsTons();
                    })
                    .catch(console.error)
            },
            fillDoughnut(data, name) {
                const colors = [...Object.keys(this.$appUtils.COLOR_RANGE)];
                this.$appUtils.fillRandomRGB(colors, data.length);
                const newData = {...this[name]};
                newData.datasets = [{data: [], backgroundColor: []}];
                newData.labels = [];
                data.forEach((d,idx) => {
                    newData.labels.push(d.name);
                    newData.datasets[0].data.push(parseFloat(d.value));
                    newData.datasets[0].backgroundColor.push(`rgba(${colors[idx]}, 0.9)`);
                });
                this[name] = {...newData};
            },
            searchDayMonth(year, product_category_id) {

                const params = new URLSearchParams();
                if (year > 0) params.append('year', year);
                if (product_category_id > 0) params.append('product_category_id', product_category_id);

                return new Promise((resolve, reject) => {
                    this.$appHttp.get(`/v1/dashboard/load_day_week_year?${params.toString()}`)
                        .then(({data}) => {
                            resolve(data)
                        })
                        .catch(reject)
                })
            },
            prepareDataToDayMonth(data) {
                const result = [];

                data.forEach(d => {
                    const splitXY = d.week_month.split('/');
                    result.push({
                        week_day: parseInt(splitXY[0]),
                        month: parseInt(splitXY[1]) - 1,
                        value: parseFloat(d.value_grouped),
                        title: this.$appUtils.formatNumber(d.value_grouped, 3)
                    })
                });
                return result;
            },
            changeYear(from) {
                const cap = from.capitalize();
                let year = null;
                if (/(one|two)/.test(from)) year = this[`year${cap}`];

                this.searchDayMonth(year, this[`product${cap}Id`])
                    .then(data => this[`dataYear${cap}`] = this.prepareDataToDayMonth(data))
                    .catch(console.error);
            },
            changeProdYearsTons() {
                const data = this.resultProdsYear.filter(r => r.id === this.productTonsYearsId);
                if (data && data.length > 0) {
                    this.dataTonsProdYears= {
                        labels: [],
                        datasets: []
                    };
                    this.dataTonsProdYearsTotal = {
                        datasets: [{
                            data: [],
                            backgroundColor: [],
                            label: 'Acumulado Ano'
                        }],
                        labels: []
                    };
                    this.fillTonsYear(data[0].years, 'dataTonsProdYears', 'dataTonsProdYearsTotal');
                }
            },
            fillTonsYear(years, lineName, doughnutName) {
                let newData = {...this[lineName]};
                let date = dayjs().startOf('year');
                const monthLabels = [];
                for (let i = 0; i < 12; i++) {
                    monthLabels.push(date.format('MMMM'));
                    date = date.add(1, 'month');
                }
                newData.labels = [...monthLabels];
                newData.datasets = [];
                years.forEach((y, idx) => {
                    const color = this.$appUtils.pSBC((idx + 0.00001) / years.length * (1.0 - -1.0) + -1.0, '#1AB39A');
                    const obj = {
                        backgroundColor: color,
                        borderColor: color,
                        data: [],
                        fill: false,
                        label: y.year,
                        borderWidth: 1,
                        pointRadius: 2
                    };
                    y.months.forEach(m => obj.data.push(parseFloat(m.value)));

                    newData.datasets.push(obj);
                });
                this[lineName] = {...newData};

                newData = {...this[doughnutName]};
                newData.datasets = [{data: [], backgroundColor: []}];
                years.forEach((y, idx) => {
                    newData.labels.push(y.year);
                    const color = this.$appUtils.pSBC((idx + 0.00001) / years.length * (1.0 - -1.0) + -1.0, '#1AB39A');
                    let total = new Big('0.0');
                    y.months.forEach(m => total = total.plus(m.value));

                    newData.datasets[0].data.push(parseFloat(total.toString()));
                    newData.datasets[0].backgroundColor.push(color);
                });
                this[doughnutName] = {...newData};
            }
        },
        mounted() {
            this.loadCategories();

            this.searchDayMonth(this.yearOne)
                .then(data =>  this.dataYearOne = this.prepareDataToDayMonth(data))
                .catch(console.error);

            this.searchDayMonth(this.yearTwo)
                .then(data =>  this.dataYearTwo = this.prepareDataToDayMonth(data))
                .catch(console.error);

            this.searchDayMonth()
                .then(data =>  this.dataYearThree = this.prepareDataToDayMonth(data))
                .catch(console.error);

            const date = dayjs();

            const previousSave = StorageUtils.getObject(FILTER_PARAMS);

            if (previousSave) {
                Object.keys(this.search_params)
                .forEach(k => {
                    if (previousSave[k]) this.$set(this.search_params, k, previousSave[k]);
                });
            } else {
                this.search_params.end = date.endOf('day').format('DD/MM/YYYY');
                this.search_params.start = date.subtract(6, 'month').startOf('day').format('DD/MM/YYYY');
            }

            this.searchDefaultCharts();
        },
        computed: {
            ...mapGetters({categories: 'categories'}),
            yearsDayMonth() {
                let date = dayjs();
                const years = [];

                while (date.format('YYYY') !== '2014') {
                    years.push(date.format('YYYY'));
                    date = date.subtract(1, 'year');
                }

                return years
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../assets/css/variables";
    .summarize {
        display: grid;
        width: fit-content;
        grid-template-columns: 1fr 3fr 3fr;
        grid-template-rows: 1fr;
        grid-template-areas: 'icon qtd tons';
        align-items: center;
        justify-items: flex-end;

        svg {
            color: $theme_color_three;
            width: 2.7em;
            height: 2.7em;
        }

        .qtd, .tons {
            color: $theme_color_three;
            text-align: center;
            span {
                font-weight: bold;
            }
        }
        .qtd {
            grid-area: qtd;
        }
        .tons {
            grid-area: tons;
        }
    }

    .horizontal-chart {
        height: 300px
    }

    @media only screen and (max-width: 800px) {
        .horizontal-chart {
            overflow-x: auto;
            width: 100%;
            height: auto;
        }
    }
</style>
